import './nav.css';
export default {
  "button": "pf-v6-c-button",
  "dirRtl": "pf-v6-m-dir-rtl",
  "menu": "pf-v6-c-menu",
  "menuList": "pf-v6-c-menu__list",
  "menuListItem": "pf-v6-c-menu__list-item",
  "modifiers": {
    "overflowHidden": "pf-m-overflow-hidden",
    "inset": "pf-m-inset",
    "fill": "pf-m-fill",
    "drilldown": "pf-m-drilldown",
    "expanded": "pf-m-expanded",
    "hover": "pf-m-hover",
    "current": "pf-m-current",
    "flyout": "pf-m-flyout",
    "horizontal": "pf-m-horizontal",
    "subnav": "pf-m-subnav",
    "scrollable": "pf-m-scrollable"
  },
  "nav": "pf-v6-c-nav",
  "navItem": "pf-v6-c-nav__item",
  "navLink": "pf-v6-c-nav__link",
  "navLinkIcon": "pf-v6-c-nav__link-icon",
  "navList": "pf-v6-c-nav__list",
  "navNav": "pf-v6-c-nav__nav",
  "navScrollButton": "pf-v6-c-nav__scroll-button",
  "navSection": "pf-v6-c-nav__section",
  "navSectionTitle": "pf-v6-c-nav__section-title",
  "navSubnav": "pf-v6-c-nav__subnav",
  "navToggle": "pf-v6-c-nav__toggle",
  "navToggleIcon": "pf-v6-c-nav__toggle-icon"
};